import script from "./lyInputNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./lyInputNumber.vue?vue&type=script&setup=true&lang=js"

import "./lyInputNumber.vue?vue&type=style&index=0&id=647a6da2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-647a6da2"]])

export default __exports__